import { supabase } from './supabase'

/**
 * Mutfak ekranları (cihazlar). Yazmalar "screens" fonksiyonundan; patron
 * listeyi doğrudan okuyor (RLS: yalnız patron).
 */

export interface KitchenScreen {
  id: string
  name: string
  /** Boş = bütün tezgahlar. */
  stations: string[]
  /** Bir tablete bağlandı mı. */
  paired: boolean
  pairedAt?: number
}

/** Ekranın türü (30 Eki 2026): mutfak ekranı ya da kiosk tableti. */
export type ScreenKind = 'kitchen' | 'kiosk'

export interface PairCode {
  code: string
  expiresAt: number
}

async function call(body: Record<string, unknown>): Promise<Record<string, unknown>> {
  if (!supabase) throw new Error('Bağlantı yok.')
  const { data, error } = await supabase.functions.invoke('screens', { body })
  if (error) {
    const detail = (await error.context?.json?.().catch(() => null)) as { error?: string } | null
    throw new Error(detail?.error ?? 'İşlem tamamlanamadı. İnternet bağlantınızı kontrol edin.')
  }
  if (data?.error) throw new Error(String(data.error))
  return (data ?? {}) as Record<string, unknown>
}

const toCode = (r: Record<string, unknown>): PairCode => ({
  code: String(r.code),
  expiresAt: Date.parse(String(r.expiresAt)),
})

export async function listScreens(tenantId: string, kind: ScreenKind = 'kitchen'): Promise<KitchenScreen[]> {
  if (!supabase) return []
  const { data, error } = await supabase
    .from('kitchen_screens')
    .select('id, name, stations, auth_uid, paired_at')
    .eq('tenant_id', tenantId)
    .eq('kind', kind)
    .order('created_at')
  if (error) throw new Error(error.message)
  return (data ?? []).map((r) => ({
    id: String(r.id),
    name: String(r.name),
    stations: Array.isArray(r.stations) ? r.stations.map(String) : [],
    paired: !!r.auth_uid,
    pairedAt: r.paired_at ? Date.parse(String(r.paired_at)) : undefined,
  }))
}

export async function createScreen(tenantId: string, name: string, stations: string[], kind: ScreenKind = 'kitchen') {
  const r = await call({ action: 'create', tenantId, name, stations, kind })
  return { screenId: String(r.screenId), ...toCode(r) }
}

export async function newPairCode(tenantId: string, screenId: string): Promise<PairCode> {
  return toCode(await call({ action: 'code', tenantId, screenId }))
}

export async function updateScreen(tenantId: string, screenId: string, name: string, stations: string[]) {
  await call({ action: 'update', tenantId, screenId, name, stations })
}

export async function removeScreen(tenantId: string, screenId: string) {
  await call({ action: 'remove', tenantId, screenId })
}

/** Tablet: kodu verir, giriş bilgisini alır. */
export async function pairScreen(
  code: string,
): Promise<{ tenantId: string; email: string; password: string; name: string; kind: ScreenKind }> {
  const r = await call({ action: 'pair', code })
  return {
    tenantId: String(r.tenantId),
    email: String(r.email),
    password: String(r.password),
    name: String(r.name),
    kind: r.kind === 'kiosk' ? 'kiosk' : 'kitchen',
  }
}

/** Tabletin açacağı bağlantı (QR ve paylaşım). */
export const pairUrl = (code: string) => `${window.location.origin}/ekran?kod=${code}`
